export default __webpack_public_path__ + "static/media/home_1.ef4ecef2.PNG";